<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>金币明细</el-breadcrumb-item>
    </el-breadcrumb>
    <ex-table
      ref="table"
      :new-btn="handleAdd"
      :load-and-request="false"
      :request="fetchData"
    >
      <ex-table-column
        prop="id"
        label="ID"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="flowNo"
        label="编号"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="accountId"
        label="用户ID"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="coins"
        label="金币数"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="type"
        label="类型"
        align="center"
        data-type="select"
        :options="typeOptions"
      ></ex-table-column>
      <ex-table-column
        prop="rechargeComboId"
        label="充值套餐ID"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="rechargePrice"
        label="充值价格"
        align="center"
        data-type="money"
      ></ex-table-column>
      <ex-table-column
        prop="platformType"
        label="类型"
        align="center"
        data-type="select"
        :options="platformTypeOptions"
      ></ex-table-column>
      <ex-table-column
        prop="orderId"
        label="订单ID"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="remark"
        label="备注"
        align="center"
      ></ex-table-column>
      <ex-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      ></ex-table-column>
    </ex-table>
  </div>
</template>

<script>
import {
  addMemberCombo,
  deleteMemberCombo,
  memberComboList,
  updateMemberCombo,
} from "../../api/configMG";
import {newRechargeCombo, pageCoinFlow, pageRechargeCombo, updateRechargeCombo} from "../../api/rechargeMG";

export default {
  data() {
    return {
      show: false,
      form: {
        title: '',
        orderNo: undefined,
        price: undefined,
        duration: undefined,
        durationRemark: '',
        remark: '',
        status: 0
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        orderNo: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格/分', trigger: 'blur' }
        ],
        coins: [
          { required: true, message: '请输入时长', trigger: 'blur' }
        ],
      },
      statusOptions: [
        { value: 0, label: '禁用' },
        { value: 1, label: '开启' }
      ],
      typeOptions: [
        // 1-充值，2-官方赠送，3-系统扣减 4-超级喜欢
        { value: 1, label: '充值' },
        { value: 2, label: '官方赠送' },
        { value: 3, label: '系统扣减' },
        { value: 4, label: '超级喜欢' }
      ],
      platformTypeOptions: [
        { value: 0, label: '多端展示' },
        { value: 1, label: '微信小程序' },
        { value: 2, label: '抖音小程序' },
        { value: 3, label: 'PC官网' },
        { value: 4, label: '移动官网' },
        { value: 5, label: 'Android' },
        { value: 6, label: 'IOS' }
      ],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.table.search();
    })
  },
  methods: {
    async fetchData(params) {
      let res = await pageCoinFlow(params)
      return new Promise((c) => {
        c({
          records: res.data.records,
          total: res.data.total
        })
      })
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Ordermanagement/CoinFlow.vue